import { User } from 'ha/services/apiV2/types/User';
import {
  ProfileEditActionTypes as ActionTypes,
  ProfileEditActions,
} from 'ha/modules/AuthLogic/constants';

interface Result {
  type: ActionTypes;
  error: boolean;
  payload: object;
}

export default function updateUserProfile(payload: Partial<User>): Result {
  return {
    type: ProfileEditActions.UPDATE_USER,
    error: false,
    payload,
  };
}
